import {RecentOrderItemType, RecentOrderType} from 'src/types/RecentOrders';
import Localized from 'src/constants/AppStrings';
import {View, StyleSheet} from 'react-native';
import Styles from 'src/components/Styles';
import AVText from 'src/components/elements/AVText';
import RecentComboIcon from 'src/components/img/svg/RecentComboIcon';
import RecentOrderCanteen from 'src/components/elements/orderAhead/recentOrder/RecentOrderCanteen';

export function getRecentOrderListItem(
  item: RecentOrderType,
  addItem: (item: RecentOrderItemType) => void,
  addAllItems: (order: RecentOrderType) => void,
  onProductCellPressed: (item: RecentOrderItemType) => void,
) {
  return (
    <RecentOrderCanteen
      recentOrder={item}
      strings={Localized}
      addItem={addItem}
      addAllItems={addAllItems}
      productCellPressed={onProductCellPressed}
    />
  );
}

export function getEmptyList() {
  return (
    <View style={styles.emptyView}>
      <AVText
        style={styles.emptyText}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
      >
        {Localized.Labels.no_recent_orders}
      </AVText>
      <View style={styles.iconView}>
        <RecentComboIcon
          fillColor={Styles.Colors.Canteen.darkGreen}
          secondaryColor={Styles.Colors.Canteen.lightGreen}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyView: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: Styles.Spacing.m3,
    gap: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  emptyText: {
    fontSize: Styles.Fonts.f7,
    fontFamily: Styles.FontFamily.robotoRegular,
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
  },
  iconView: {alignSelf: 'center'},
});

export default {
  getRecentOrderListItem,
  getEmptyList,
};
